import { notification } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext, RefreshStatus } from '../../App';
import {
  fetchRawData,
  getAnalyticsStatus,
  getDetails,
  getOverallFields,
} from '../../Services/PFMClient/DashboardService';
import { FlowType } from '../../Utils/constants';
import {
  EVENTCODES,
  pushEventToParent,
  pushEventToPosthog,
} from '../../Utils/eventUtils';
import { ROUTES } from '../../Utils/routes';
import {
  getExistingUserJourneyStartedOnce,
  getTenant,
  getTrackingId,
  getUserId,
  setExistingUserJourneyStartedOnce,
  setTrendsVisible,
  trendsVisible,
} from '../../Utils/storageUtils';
import { TenantType } from '../../Utils/types';
import AssetsDashboard from '../Dashboard/AssetsDashboard';
import Spends from '../Dashboard/Spends';
import Stocks from '../Dashboard/Stocks';
import NativeLoader from '../NativeLoader';
import NudgesScreenDashboard from '../Dashboard/NudgesScreenDashboard';
import HoldingsScreen from '../PaisaBazaar/StocksNewFlow/HoldingsScreen';
import MahindraBankSummary from '../Mahindra/AA/BankSummary';
import styles from './index.module.css';
import { ASSETSTYPE } from '../HomePageNew';
import YBMutualFunds from '../YesBank/MutualFunds';

type props = {
  setCurrentRoute?: any;
};

export const enum VIEWTYPE {
  SPENDSVIEW,
  ASSETSVIEW,
  STOCKSVIEW,
  BANKSUMMARYVIEW,
  HOLDINGSVIEW,
  MUTUALFUNDSVIEW,
}

const HomePage: React.FC<props> = ({ setCurrentRoute }) => {
  const {
    data,
    analyticsStatus,
    setAnalyticsStatus,
    analyticsStatusRef,
    isLoading,
    setIsLoading,
    accountsData,
    setNudges,
    setAccountIds,
    stocksData,
    setStocksData,
    statusData,
    isAccountDetailsFetched,
    setIsAccountDetailsFetched,
    analyticsStatusStocks,
    setAnalyticsStatusStocks,
    statusPolling,
    isLoaderBackEventSent,
    setDataRefreshStatus,
    dataRefreshStatusRef,
    termRecurringData,
    setTermRecurringData,
    otherDepositBalance,
    isPollingInProgress,
    isBackEventSent,
    isKeyInshigtsVisible,
    selectedNudge,
    startAdditionalAccountJourney,
    setUpdateStatusPollingAnalyticsStatus,
    ViewType,
    setViewType,
    datafromAnalyticsStatus,
    setForceRender,
  }: any = useContext(AppContext);

  const navigate = useNavigate();
  const location = useLocation();

  let previousLength: number = -1;

  const dataFetchLinkRef = useRef<any[]>([]);

  const rawDataFetchId = useRef<string[]>([]);
  const totalAccounts = useRef(0);
  const [isInitialRenderingCompleted, setIsInitialRenderingCompleted] =
    useState(getTenant() === TenantType.PB ? false : true);
  const [selectedHolding, setSelectedHolding] = useState<any>(null);

  let totalCount = 0;

  const getAssetsDetails = async () => {
    return new Promise((resolve) => {
      getDetails({
        type: 'ASSET',
      })
        .then((res) => resolve(res))
        .catch((err) => resolve('error'));
    });
  };

  const getOverallFieldsOfStocks = async () => {
    return new Promise((resolve) => {
      getOverallFields()
        .then((res) => resolve(res))
        .catch((err) => resolve('error'));
    });
  };

  const getDetailsMethod = async () => {
    return new Promise((resolve) => {
      getDetails({
        type: 'ACCOUNT_DETAILS',
      })
        .then((res) => resolve(res))
        .catch((err) => resolve('error'));
    });
  };

  const getTop5FundTransfer = async () => {
    return new Promise((resolve, reject) => {
      getDetails({
        type: 'TOP5_FUNDS_TRANSFER',
      })
        .then((res) => resolve(res))
        .catch(() => resolve('error'));
    });
  };

  const getNudgesMethod = async () => {
    return new Promise((resolve, reject) => {
      getDetails({
        type: 'NUDGES',
      })
        .then((res) => resolve(res))
        .catch((err) => resolve('error'));
    });
  };

  const getMutualFundsDetails = async () => {
    return new Promise((resolve) => {
      getDetails({
        type: 'MUTUAL_FUNDS',
      })
        .then((res) => resolve(res))
        .catch(() => resolve('error'));
    });
  };

  // const getStocksInisights = async () => {
  //   return new Promise((resolve, reject) => {
  //     getDetails({
  //       type: 'STOCK_INSIGHT',
  //     })
  //       .then((res) => resolve(res))
  //       .catch((err) => reject(err));
  //   });
  // };
  // const getStockHoldings = async () => {
  //   return new Promise((resolve, reject) => {
  //     getDetails({
  //       type: 'STOCK_HOLDING',
  //     })
  //       .then((res) => resolve(res))
  //       .catch((err) => reject(err));
  //   });
  // };

  const throwError = () => {
    if (analyticsStatusRef.current === 'PENDING') {
      notification.error({ message: 'Fail to fetch the data.' });
      setCurrentRoute(ROUTES.LANDING);
      isLoaderBackEventSent.current = true;

      setIsLoading(false);
      pushEventToParent({ eventCode: 'SESSION_TIMEOUT' });
    }
  };

  const getDetailsPromise = async () => {
    const values: any[] = await Promise.all([
      getAssetsDetails(),
      getDetailsMethod(),
      getNudgesMethod(),
      getTop5FundTransfer(),
      getOverallFieldsOfStocks(),
      getMutualFundsDetails(),

      // getStockHoldings(),
      // getStocksInisights(),
    ]);

    let top5FundTransfer: any = {};
    let assets: any = {};
    let account_details: any = {};
    let nudges: any[] = [];
    let totalPortfolioValue: any = {};
    let mutualFunds: any = {};
    // let inisights: any[] = [];
    // let holdings: any[] = [];

    if (values[0] !== 'error') {
      assets = values[0].data;
      if (assets) {
        pushEventToParent({
          eventCode: EVENTCODES.ASSETS_FETCH_SUCCESS,
        });
      }
    }
    if (values[1] !== 'error') {
      account_details = values[1].data;
    }

    if (values[2] !== 'error') {
      nudges = values[2].data.nudges;
    }

    if (values[3] !== 'error') {
      top5FundTransfer = values[3].data.overall;
    }

    if (values[4] !== 'error') {
      totalPortfolioValue = values[4].data.totalPortfolioValue;
    }

    if (values[5] !== 'error') {
      mutualFunds = values[5].data;
    }

    data.current = {
      ...data.current,
      ASSET: assets,
      ACCOUNT_DETAILS: account_details,
      NUDGES: nudges,
      TOP5FUNDTRANSFER: top5FundTransfer,
      totalPortfolioValue,
      MUTUAL_FUNDS: mutualFunds,
    };
    setNudges(data.current.NUDGES);
    setForceRender((n: number) => n + 1);

    if (
      data.current.ACCOUNT_DETAILS &&
      data.current.ACCOUNT_DETAILS.accountProfileList
    ) {
      setAccountIds(
        data.current.ACCOUNT_DETAILS.accountProfileList.map(
          (accountProfile: any) => accountProfile.account.id
        )
      );
      dataFetchLinkRef.current =
        data.current.ACCOUNT_DETAILS.accountProfileList.map(
          (accountProfile: any) => accountProfile.account.linkedAccRef
        );

      setAccountsData();
    }
    setIsAccountDetailsFetched(true);
    isLoaderBackEventSent.current = true;

    setIsLoading(false);
  };

  const setAccountsData = () => {
    data.current.ACCOUNT_DETAILS.accountProfileList.forEach(
      (accountLocal: any) => {
        const dataTest: any[] = accountLocal.monthlyAnalytics
          ? accountLocal.monthlyAnalytics.map((monthlyAnalytics: any) => {
              return {
                creditAmount: monthlyAnalytics.totalCreditAmount,
                debitAmount: monthlyAnalytics.totalDebitAmount,
                yearMonth: monthlyAnalytics.month + '' + monthlyAnalytics.year,
                investment: monthlyAnalytics.totalInvestmentExpense,
              };
            })
          : [];

        accountsData.current = {
          ...accountsData.current,
          [accountLocal.account.linkedAccRef]: {
            ...accountsData.current[accountLocal.account.linkedAccRef],
            monthlyAnalysis: dataTest,
          },
        };
      }
    );
  };

  const getRawData = async (id?: any[]) => {
    let rawDataId = statusData.current.accountDetails
      .map((acc: any) => {
        if (acc.lastRawDataFetchedAt && acc.status === 'ACTIVE') {
          return acc.lastRawDataId;
        } else {
          return null;
        }
      })
      .filter((a: any) => a != null);

    const findDifference = rawDataId.filter(
      (x: any) => !rawDataFetchId.current.includes(x)
    );

    if ((id && id.length > 0) || findDifference.length > 0) {
      await fetchRawData({
        dataRequestDetailsIds: id && id.length > 0 ? id : findDifference,
      }).then((res) => {
        totalAccounts.current = statusData.current.accountDetails.length;
        rawDataFetchId.current = [...rawDataFetchId.current, ...findDifference];

        let totalBalance =
          data.current &&
          data.current.ASSET &&
          data.current.ASSET.closingBalance
            ? data.current.ASSET.closingBalance
            : 0;

        let formattedRawData: any = {};
        res.data.forEach((d: any) => {
          if (d.rawData && d.rawData.Summary && d.rawData.type === 'deposit') {
            formattedRawData[d.rawData.linkedAccRef] =
              parseInt(d.rawData.Summary.currentBalance) ?? 0;
            totalBalance += parseInt(d.rawData.Summary.currentBalance) ?? 0;
          } else if (
            d.rawData &&
            d.rawData.Summary &&
            (d.rawData.type === 'term_deposit' ||
              d.rawData.type === 'recurring_deposit')
          ) {
            formattedRawData[d.dataRequestDetailsId] =
              parseInt(d.rawData.Summary.currentValue || 0) ?? 0;
            otherDepositBalance.current +=
              parseInt(d.rawData.Summary.currentValue || 0) ?? 0;
          }
        });

        data.current = {
          ...data.current,
          ASSET: {
            closingBalance: totalBalance,
            totalAccounts: statusData.current.accountDetails.filter(
              (acc: any) =>
                acc.fiType === 'DEPOSIT' &&
                acc.lastRequestFIStatus === 'DELIVERED'
            ).length,
          },
          RAW_DATA: { ...data.current.RAW_DATA, ...formattedRawData },
          USERNAME: res.data[0]?.rawData?.Profile?.Holders?.Holder[0]?.name
            ? res.data[0].rawData.Profile.Holders.Holder[0]?.name
            : 'User',
        };

        setForceRender((n: number) => n + 1);

        pushEventToParent({
          eventCode: EVENTCODES.RAW_DATA_FETCHED,
        });

        const stocksFilter = res.data.filter(
          (rawDataObject: any) =>
            rawDataObject?.rawData?.type?.toLowerCase() === 'equities' ||
            rawDataObject?.rawData?.type?.toLowerCase() === 'etf'
        );

        const termRecurringFilter = res.data.filter(
          (rawDataObject: any) =>
            rawDataObject?.rawData?.type === 'recurring_deposit' ||
            rawDataObject?.rawData?.type === 'term_deposit'
        );

        if (termRecurringFilter.length > 0) {
          addItemsTermRecurringDeposit(termRecurringFilter, id ? id : []);
        }

        if (stocksFilter.length > 0) {
          setAnalyticsStatusStocks('DELIVERED');
          addItems(stocksFilter, id ? id : []);
        }
      });
    }
  };

  const addItemsTermRecurringDeposit = (newItemsArray: any, id: any[]) => {
    const uniqueItems = newItemsArray.filter(
      (newItem: any) =>
        !termRecurringData.some(
          (existingItem: any) =>
            existingItem.dataRequestDetailsId === newItem.dataRequestDetailsId
        )
    );

    let termRecurringDataLocal =
      id && id.length > 0 ? [] : [...termRecurringData];
    termRecurringDataLocal.push(...uniqueItems);

    setTermRecurringData(termRecurringDataLocal);
  };

  const addItems = (newItemsArray: any, id: any[]) => {
    const uniqueItems = newItemsArray.filter(
      (newItem: any) =>
        !stocksData.some(
          (existingItem: any) =>
            existingItem.dataRequestDetailsId === newItem.dataRequestDetailsId
        )
    );

    let stocksDataLocal = id && id.length > 0 ? [] : [...stocksData];
    stocksDataLocal.push(...uniqueItems);

    setStocksData(stocksDataLocal);
  };

  const fetchStocksRawData = async () => {
    const filterStocksData = statusData.current.accountDetails
      .map((acc: any) => {
        if (
          acc.lastRawDataFetchedAt &&
          acc.status === 'ACTIVE' &&
          acc.fiType === 'EQUITIES'
        ) {
          return acc.lastRawDataId;
        } else {
          return null;
        }
      })
      .filter((a: any) => a != null);

    if (filterStocksData && filterStocksData.length > 0) {
      await getRawData(filterStocksData);
    }
  };

  const checkDataRefreshStatus = async () => {
    const statusDataLocal = statusData.current;

    if (statusDataLocal.refreshAvailable) {
      setDataRefreshStatus(RefreshStatus.REFRESH_AVAILABLE);
    } else if (
      statusDataLocal.status === 'ASYNC_COMPLETED' &&
      statusDataLocal.lastRefreshStatus === 'COMPLETED' &&
      dataRefreshStatusRef.current === RefreshStatus.IN_PROGRESS
    ) {
      let totalDepositAccounts = 0;
      let totalStocksAccounts = 0;
      let totalCompletedDataFetch = 0;
      let totalFailedDataFetch = 0;

      statusData.current.accountDetails.forEach((r: any) => {
        if (r.status === 'ACTIVE' && r.fiType === 'DEPOSIT') {
          totalDepositAccounts += 1;

          if (
            r.lastRequestAnalyticsStatus === 'ASYNC_COMPLETED' &&
            r.lastRequestFIStatus === 'DELIVERED'
          ) {
            totalCompletedDataFetch += 1;
          } else if (r.status === 'ACTIVE' && r.fiType === 'DEPOSIT') {
            totalFailedDataFetch += 1;
          }
        }

        if (
          r.status === 'ACTIVE' &&
          (r.fiType === 'EQUITIES' || r.fiType === 'ETF')
        ) {
          totalStocksAccounts += 1;

          if (
            r.lastRequestFIStatus === 'DATA_NOT_RETURNED_IN_TIME' ||
            r.lastRequestFIStatus === 'TIMEOUT' ||
            r.lastRequestFIStatus === 'DENIED'
          ) {
            totalFailedDataFetch += 1;
          } else {
            totalCompletedDataFetch += 1;
          }
        }
      });

      if (
        totalDepositAccounts + totalStocksAccounts ===
        totalCompletedDataFetch
      ) {
        pushEventToParent({
          eventCode: EVENTCODES.REFRESH_COMPLETED,
        });
        setDataRefreshStatus(RefreshStatus.COMPLETED);
      } else if (
        totalDepositAccounts + totalStocksAccounts ===
        totalFailedDataFetch
      ) {
        setDataRefreshStatus(RefreshStatus.FAILURE);
      } else {
        pushEventToParent({
          eventCode: EVENTCODES.REFRESH_COMPLETED_PARTIAL,
        });
        setDataRefreshStatus(RefreshStatus.PARTIAL_COMPLETED);
      }

      await fetchStocksRawData();
    }
  };

  // Helper to get sum of closingBalance by fiType from analytics-status API
  const getFiTypeStats = () => {
    const accountDetails =
      statusData.current?.accountDetails?.filter(
        (acc: any) => acc.status !== 'INACTIVE'
      ) || [];

    const fistats = accountDetails.reduce(
      (acc: Record<string, { sum: number; count: number }>, curr: any) => {
        const { fiType, closingBalance } = curr;
        if (!fiType) return acc;
        const balance = closingBalance ? Number(closingBalance) : 0;
        if (!acc[fiType]) {
          acc[fiType] = { sum: 0, count: 0 };
        }
        acc[fiType].sum += balance;
        acc[fiType].count += 1;
        return acc;
      },
      {}
    );

    // Calculate total balance including all fiTypes
    const totalBalance = Object.values(fistats).reduce(
      (sum: number, stat: any) => sum + stat.sum,
      0
    );

    // Update the ASSET closingBalance with calculated total
    if (data.current.ASSET) {
      data.current.ASSET = {
        ...data.current.ASSET,
        closingBalance: totalBalance,
      };
    }
  };

  const makeRequestWithRetry = () => {
    if (totalCount < 100) {
      // push events only for 10 times
      if (totalCount < 10) {
        pushEventToPosthog({ eventCode: EVENTCODES.STATUS_POLLING });
      }

      getAnalyticsStatus()
        .then((res) => res.data)
        .then(async (res: any) => {
          statusData.current = res;

          // Calculate datafromAnalyticsStatus for YesBank
          if (getTenant() === TenantType.YESBANK) {
            const accountDetails =
              res.accountDetails?.filter(
                (acc: any) => acc.status === 'ACTIVE'
              ) || [];

            const fistats = accountDetails.reduce(
              (
                acc: Record<string, { sum: number; count: number }>,
                curr: any
              ) => {
                const { fiType, closingBalance } = curr;
                if (!fiType) return acc;
                const balance = closingBalance ? Number(closingBalance) : 0;
                if (!acc[fiType]) {
                  acc[fiType] = { sum: 0, count: 0 };
                }
                acc[fiType].sum += balance;
                acc[fiType].count += 1;
                return acc;
              },
              {}
            );

            datafromAnalyticsStatus.current = {
              ...datafromAnalyticsStatus.current,
              savings: fistats?.DEPOSIT?.sum || 0,
              mutualFunds: fistats?.MUTUAL_FUNDS?.sum || 0,
              equities: fistats?.EQUITIES?.sum || 0,
              etf: fistats?.ETF?.sum || 0,
            };
          }

          getFiTypeStats();
          setUpdateStatusPollingAnalyticsStatus((old: number) => old + 1);
          checkDataRefreshStatus();

          if (!trendsVisible() && res.trendsVisible) {
            setTrendsVisible(true);
          }

          const checkStatusTermRecurring: any[] = res.accountDetails.filter(
            (d: any) =>
              (d.fiType === 'TERM_DEPOSIT' ||
                d.fiType === 'RECURRING_DEPOSIT') &&
              d.status === 'ACTIVE' &&
              d.lastRequestFIStatus === 'DELIVERED'
          );

          if (
            checkStatusTermRecurring.length === res.accountDetails.length &&
            getTenant() === TenantType.YESBANK
          ) {
            setIsAccountDetailsFetched(true);
          }

          const checkStatus: any[] = res.accountDetails.filter(
            (d: any) =>
              (d.lastRequestAnalyticsStatus !== 'ASYNC_COMPLETED' &&
                d.fiType === 'DEPOSIT' &&
                d.status === 'ACTIVE' &&
                (d.lastRequestFIStatus === 'DELIVERED' ||
                  d.lastRequestFIStatus === 'PENDING' ||
                  d.lastRequestFIStatus === null)) ||
              d.status === 'REVOKE_INITIATED'
          );

          const checkStatusStocks: any[] = res.accountDetails.filter(
            (d: any) =>
              (d.fiType === 'EQUITIES' || d.fiType === 'ETF') &&
              d.status === 'ACTIVE'
          );

          const isRefreshPending = res.lastRefreshStatus === 'PENDING';

          if (
            res.status &&
            res.status !== null &&
            (res.status === 'ASYNC_PROCESSING' ||
              res.status === 'ASYNC_COMPLETED' ||
              res.status === 'REFRESH_PROCESSING' ||
              res.status === 'REFRESH_INITIATE_FAILED')
          ) {
            if (
              analyticsStatusRef.current !== 'ASYNC_PROCESSING' &&
              analyticsStatusRef.current !== 'ASYNC_COMPLETED' &&
              analyticsStatusRef.current !== 'REFRESH_PROCESSING' &&
              analyticsStatusRef.current !== 'REFRESH_INITIATE_FAILED'
            ) {
              if (analyticsStatusRef.current !== 'RAW_DATA_FETCHED') {
                await getRawData();
              }
              await getDetailsPromise();
              setAnalyticsStatus(res.status);
            }
          } else if (res.rawDataFetched) {
            if (
              analyticsStatusRef.current !== 'RAW_DATA_FETCHED' ||
              totalAccounts.current !== rawDataFetchId.current.length
            ) {
              await getRawData();
              setAnalyticsStatus('RAW_DATA_FETCHED');
              isLoaderBackEventSent.current = true;
              setIsLoading(false);
            }
          } else if (res.userConsentActive) {
            setAnalyticsStatus('CONSENT_APPROVED');
          }

          if (
            (checkStatus && checkStatus.length > 0) ||
            isRefreshPending ||
            res.status === null
          ) {
            previousLength = checkStatus.length;
          } else if (
            previousLength !== -1 &&
            previousLength !== checkStatus.length
          ) {
            previousLength = checkStatus.length;
            await getDetailsPromise();
          }

          if (checkStatus && checkStatus.length > 0) {
            const filterAcc = checkStatus.map((acc) => {
              if (
                (acc.lastRequestAnalyticsStatus === 'ASYNC_COMPLETED' ||
                  acc.lastRequestAnalyticsStatus === 'ASYNC_PROCESSING' ||
                  acc.lastRequestAnalyticsStatus === 'REFRESH_PROCESSING' ||
                  acc.lastRequestAnalyticsStatus ===
                    'REFRESH_INITIATE_FAILED') &&
                !dataFetchLinkRef.current.includes(acc.linkRefNumber)
              ) {
                return acc.linkRefNumber;
              }
            });

            if (filterAcc.filter((e) => e !== undefined).length > 0) {
              getDetailsPromise();
              dataFetchLinkRef.current =
                dataFetchLinkRef.current.concat(filterAcc);
            }
          }

          if (checkStatusStocks && checkStatusStocks.length > 0) {
            const filterStatus: any[] = checkStatusStocks.filter(
              (d: any) => d.lastRequestFIStatus !== 'DELIVERED'
            );

            if (filterStatus.length === 0) {
              await getRawData();
            }
          } else if (analyticsStatusStocks === 'PENDING') {
            setAnalyticsStatusStocks('NO_ACCOUNTS');
          }

          setTimeout(() => {
            makeRequestWithRetry();
            totalCount += 1;
          }, 5000);
        })
        .catch(() => {
          throwError();
        });
    } else {
      throwError();
      isPollingInProgress.current = false;
    }
  };

  useEffect(() => {
    if (
      (analyticsStatus === 'PENDING' || analyticsStatusStocks === 'PENDING') &&
      !isPollingInProgress.current
    ) {
      isPollingInProgress.current = true;
      makeRequestWithRetry();
    } else if (
      (analyticsStatus === 'PENDING' || analyticsStatusStocks === 'PENDING') &&
      isPollingInProgress.current
    ) {
      totalCount = 0;
    }
  }, [statusPolling]);

  // ViewType state is now managed in AppContext

  const onClick = (assestType: ASSETSTYPE) => {
    if (assestType === ASSETSTYPE.BANKS) {
      setViewType(VIEWTYPE.SPENDSVIEW);
    }
    if (assestType === ASSETSTYPE.EQUITIES) {
      setViewType(VIEWTYPE.STOCKSVIEW);
    }
    if (assestType === ASSETSTYPE.MUTUAL_FUNDS) {
      setViewType(VIEWTYPE.MUTUALFUNDSVIEW);
    }
  };

  const renderView = () => {
    if (!isInitialRenderingCompleted) {
      return <></>;
    }
    switch (ViewType) {
      case VIEWTYPE.BANKSUMMARYVIEW:
        return (
          <MahindraBankSummary
            onSpendsView={() => setViewType(VIEWTYPE.SPENDSVIEW)}
            onDashboardView={() => setViewType(VIEWTYPE.ASSETSVIEW)}
          />
        );
      case VIEWTYPE.SPENDSVIEW:
        return (
          <Spends
            onBack={() => {
              setViewType(VIEWTYPE.ASSETSVIEW);
              isBackEventSent.current = false;
            }}
            defaultTab={'1'}
          />
        );
      case VIEWTYPE.STOCKSVIEW:
        return (
          <Stocks
            onHoldingClick={(holding: any) => {
              setSelectedHolding(holding);
              setViewType(VIEWTYPE.HOLDINGSVIEW);
              navigate('/holdings');
            }}
          />
        );
      case VIEWTYPE.HOLDINGSVIEW:
        return data?.current?.totalPortfolioValue && selectedHolding ? (
          <HoldingsScreen holdingData={selectedHolding} />
        ) : (
          <AssetsDashboard onClick={onClick} />
        );
      case VIEWTYPE.MUTUALFUNDSVIEW:
        return (
          getTenant() === TenantType.YESBANK && (
            <YBMutualFunds
              onBack={() => {
                setViewType(VIEWTYPE.ASSETSVIEW);
                isBackEventSent.current = false;
              }}
            />
          )
        );
      case VIEWTYPE.ASSETSVIEW:
        return <AssetsDashboard onClick={onClick} />;
      default:
        return <AssetsDashboard onClick={onClick} />;
    }
  };

  useEffect(() => {
    const tenant = getTenant();
    if (tenant === TenantType.PB && isAccountDetailsFetched) {
      setIsInitialRenderingCompleted(true);
      if (location.pathname.includes('/spends')) {
        if (
          statusData.current.accountDetails.filter(
            (accountDetail: any) =>
              accountDetail.fiType === 'DEPOSIT' &&
              accountDetail.status !== 'INACTIVE'
          ).length === 0 &&
          !getExistingUserJourneyStartedOnce()
        ) {
          startAdditionalAccountJourney(FlowType.BANKS);
          setExistingUserJourneyStartedOnce(true);
        } else {
          setViewType(VIEWTYPE.SPENDSVIEW);
          navigate(location.pathname, { state: location.state });
        }
      } else if (location.pathname.includes('/stocks')) {
        if (
          statusData.current.accountDetails.filter((acc: any) => {
            return (
              (acc.fiType === 'EQUITIES' || acc.fiType === 'ETF') &&
              acc.status === 'ACTIVE'
            );
          }).length <= 0
        ) {
          startAdditionalAccountJourney(FlowType.STOCKS);
        } else {
          setViewType(VIEWTYPE.STOCKSVIEW);
          navigate('/stocks', { state: location.state });
        }
      } else if (location.pathname.includes('/holdings')) {
        setViewType(VIEWTYPE.HOLDINGSVIEW);
        navigate('/holdings');
      } else if (
        location.pathname.includes('/home') ||
        location.pathname === '/'
      ) {
        navigate('/home');
        setViewType(VIEWTYPE.ASSETSVIEW);
      }
    }
  }, [location.pathname, isAccountDetailsFetched]);

  return !isInitialRenderingCompleted ? (
    <NativeLoader />
  ) : isLoading && getTenant() !== TenantType.YESBANK ? (
    <></>
  ) : (
    <>
      {isKeyInshigtsVisible || selectedNudge ? (
        <NudgesScreenDashboard />
      ) : (
        <></>
      )}
      {!isKeyInshigtsVisible && !selectedNudge ? (
        <div className={styles.dashboard_main_div}>{renderView()}</div>
      ) : (
        <></>
      )}
    </>
  );
};

export default HomePage;
